import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ApprovePropertyTab from "../../components/PropertyView/ApprovePropertyTab";
import ApproveDetailsTab from "../../components/PropertyView/ApproveDetailsTab";
import ApproveRoomsTab from "../../components/PropertyView/ApproveRoomsTab";
import DocumentVerificationApprove from "../../components/PropertyView/DocumentVerificationApprove";
import FollowUp from "../Property/FollowUp";
import AddDocument from "./AddDocument";
import MmcPayment from "./MmcPayment";

const ApprovePropertyView = () => {
  const location = useLocation();
  const tab = location?.state?.tab
  const data = location.state
  const value = data?.data?.property_type

  const property_id = location?.state?.property_id
  const owner_id = location?.state?.owner_id



  const [details, setDetails] = useState({})


  console.log('ApproveTab', tab)

  const [tabs, setTabs] = useState(tab ? tab : 1);




  console.log('dataApproved', data?.data)
  // console.log('detailsApp', details)

  console.log('document_status', data?.data?.document_status)




  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Approve Property View
        </h2>
      </div>
      <div className='d-flex gap-4 mt-3'>
        <h2 onClick={() => { setTabs(1) }} className={`${tabs == 1 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Property
        </h2>
        <h2 onClick={() => { setTabs(2) }} className={`${tabs == 2 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Details
        </h2>
        {value == 1 && (
          <h2 onClick={() => { setTabs(3) }} className={`${tabs == 3 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
            Rooms
          </h2>
        )}

        {(tab || data?.data?.document_status == 0) && (<h2 onClick={() => { setTabs(6) }} className={`${tabs == 6 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Document
        </h2>)}




        {data?.data?.document_status == 2 && (
          <h2
            onClick={() => setTabs(4)}
            className={`${tabs == 4 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
          >
            Document Verification
          </h2>
        )}


        {(tab || data?.data?.document_status == 2) && (<h2 onClick={() => { setTabs(7) }} className={`${tabs == 7 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          MMC
        </h2>)}
        <h2 onClick={() => { setTabs(5) }} className={`${tabs == 5 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Follow Ups
        </h2>
      </div>

      {tabs == 1 && (
        <ApprovePropertyTab data={data} setTabs={setTabs} setDetails={setDetails} owner_id={owner_id} property_id={property_id} />
      )}
      {tabs == 2 && (
        <ApproveDetailsTab data={data} setTabs={setTabs} property_id={property_id} />
      )}
      {tabs == 3 && <ApproveRoomsTab data={data} setTabs={setTabs} />}
      {tabs == 4 && <DocumentVerificationApprove data={data} setTabs={setTabs} value={value} />}
      {tabs == 5 && <FollowUp data={data} />}
      {tabs == 6 && <AddDocument propertyId={data?.data?.id ? data?.data?.id : property_id} setTabs={setTabs} setDetails={setDetails} />}
      {tabs == 7 && <MmcPayment data={data} details={details} property_id={property_id} owner_id={owner_id} />}
    </div>
  );
};

export default ApprovePropertyView